/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import navbarSearchAndPinList from "@/app/shared/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import appConfig from '@/../appConfig.js';

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin"
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}

/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - START
 * 
******************************************************************************/
// Set default values for app-scope
// More data can be added by app configurator or other plugins/packages
const getAppConf = () => {
  let appConf = JSON.parse(localStorage.getItem("app.conf")) || {}

  return appConf;
}

// Set default values for app-scope
// More data can be added by app configurator or other plugins/packages
const getAppScope = () => {
  let appScope = JSON.parse(localStorage.getItem("app.scope")) || {}

  return appScope;
}

/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - END
 * 
******************************************************************************/


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : getUserInfo(),
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : appConfig.navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : appConfig.navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,


/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - START
 * 
******************************************************************************/
    // AppConf Definition ( Default Setting or Specify App level Conf )
    AppConf                : getAppConf(),
    AppConfTrack           : 0,
    // Scope Definition ( Default Setting or Specify App level Scope )
    AppScope                : getAppScope(),
    AppScopeTrack           : 0
/******************************************************************************
 * 
 * APPYVUE CUSTOMIZATION - END
 * 
******************************************************************************/    
}

export default state
